import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm } from "../../data/site";
import { homeMedia } from "../../data/homeMedia";
import { actionClass } from "../../utils/actionStyles";
export function Hero() {
  return <section aria-labelledby="hero-title" className="border-b border-line bg-ivory" data-id="element-172" data-mp="jnx6bkq0jvgo">
      <div className="page-container grid gap-10 py-12 md:py-16 lg:grid-cols-12 lg:items-center lg:gap-16" data-id="element-173" data-mp="ep3urxuaeej5">
        <div className="lg:col-span-7" data-id="element-174" data-mp="apbipb5opq91">
          <h1 id="hero-title" className="text-h1-m font-extrabold text-ink md:text-h1" data-id="element-175" data-mp="am77httsxu8v">
            Michigan Motorcycle Accident Lawyer
          </h1>
          <p className="mt-5 max-w-measure text-slate md:mt-6" data-id="element-176" data-mp="rf76i8u4tae">
            Jason Waechter, The Motorcycle Lawyer®, helps injured Michigan riders protect evidence, deal with
            insurance pressure, and understand their options after a serious motorcycle crash.
          </p>
          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap" data-id="element-177" data-mp="1q5284dwhzmq6">
            <a href={firm.phoneHref} className={actionClass("call", "sm:px-7")} data-id="element-178" data-mp="1mwm2i163bu70">
              <PhoneIcon aria-hidden="true" className="h-5 w-5" data-id="element-179" data-mp="1myp1hap80xnv" />
              Call {firm.phoneDisplay}
            </a>
            <a href="#case-review" className={actionClass("outline", "sm:px-7")} data-id="element-180" data-mp="1cyepftex9waa">
              Free Case Review
            </a>
          </div>
          <p className="mt-5 text-meta text-slate" data-id="element-181" data-mp="1hxrmf6zicjql">Free case review for Michigan motorcycle injury cases.</p>
        </div>
        <figure className="mx-auto w-full max-w-[480px] lg:col-span-5" data-id="element-182" data-mp="25ox13itpp5zb">
          <img src={homeMedia.hero.src} srcSet={homeMedia.hero.srcSet} sizes="(min-width: 1024px) 480px, (min-width: 640px) 480px, calc(100vw - 40px)" width={homeMedia.hero.width} height={homeMedia.hero.height} alt={homeMedia.hero.alt} loading="eager" fetchPriority="high" decoding="async" className="block h-auto w-full rounded-lg border border-line" data-id="element-183" data-mp="2aklut5j1vsnp" />
          <figcaption className="mt-3 text-meta text-slate" data-id="element-184" data-mp="337c1t5o2obij">Jason Waechter, The Motorcycle Lawyer®</figcaption>
        </figure>
      </div>
    </section>;
}